import { gql } from "~/__generated__"

export const CHECK_POST = gql(/* GraphQL */ `
  mutation CheckPost($input: PostCheckInput!) {
    postCheck(input: $input) {
      check {
        id
        body
        status
        score
        message
      }
    }
  }
`)
